/*
 * jQuery Iframe Transport Plugin 1.6
 * https://github.com/blueimp/jQuery-File-Upload
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/MIT
 */

/*jslint unparam: true, nomen: true */
/*global define, window, document */

(function (factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        // Register as an anonymous AMD module:
        define(['jquery'], factory);
    } else {
        // Browser globals:
        factory(window.jQuery);
    }
}(function ($) {
    'use strict';

    // Helper variable to create unique names for the transport iframes:
    var counter = 0;

    // The iframe transport accepts three additional options:
    // options.fileInput: a jQuery collection of file input fields
    // options.paramName: the parameter name for the file form data,
    //  overrides the name property of the file input field(s),
    //  can be a string or an array of strings.
    // options.formData: an array of objects with name and value properties,
    //  equivalent to the return data of .serializeArray(), e.g.:
    //  [{name: 'a', value: 1}, {name: 'b', value: 2}]
    $.ajaxTransport('iframe', function (options) {
        if (options.async && (options.type === 'POST' || options.type === 'GET')) {
            var form,
                iframe;
            return {
                send: function (_, completeCallback) {
                    form = $('<form style="display:none;"></form>');
                    form.attr('accept-charset', options.formAcceptCharset);
                    // javascript:false as initial iframe src
                    // prevents warning popups on HTTPS in IE6.
                    // IE versions below IE8 cannot set the name property of
                    // elements that have already been added to the DOM,
                    // so we set the name along with the iframe HTML markup:
                    iframe = $(
                        '<iframe src="javascript:false;" name="iframe-transport-' +
                            (counter += 1) + '"></iframe>'
                    ).bind('load', function () {
                        var fileInputClones,
                            paramNames = $.isArray(options.paramName) ?
                                    options.paramName : [options.paramName];
                        var deferred = $.Deferred();
                        iframe
                            .unbind('load')
                            .bind('load', function () {
                                if (!options.crossDomain) {
                                    deferred.resolve("success", $(iframe.contents()[0].body).text());
                                } else {
                                    setTimeout(function() {
                                        if (deferred.state() === "pending") {
                                            deferred.reject("timed out");
                                        }
                                    }, 500); // wait 0.5s for message to be sent before giving up
                                }
                            });
                        deferred.always(function(statusText, data) {
                            // The complete callback returns the
                            // iframe's content (as text) as response object:
                            var statusCode = (statusText == "success") ? 200 : 504;
                            completeCallback(
                                statusCode,
                                statusText,
                                {'iframe': data}
                            );
                            // Fix for IE endless progress bar activity bug
                            // (happens on form submits to iframe targets):
                            $('<iframe src="javascript:false;"></iframe>')
                                .appendTo(form);
                            form.remove();
                        });
                        if (options.crossDomain) {
                            options.url = Utilities.addParams(options.url, {'responseAs': 'postMessage'})
                        }
                        form
                            .prop('target', iframe.prop('name'))
                            .prop('action', options.url)
                            .prop('method', options.type);
                        if (options.formData) {
                            if (options.csrfToken) {
                                options.formData.push({
                                    'name': 'csrfmiddlewaretoken',
                                    'value': options.csrfToken
                                });
                            } else if (options.referrerHMAC) {
                                options.formData.push({
                                    'name': 'http_referrer_hmac',
                                    'value': options.referrerHMAC
                                });
                            }
                            $.each(options.formData, function (index, field) {
                                $('<input type="hidden"/>')
                                    .prop('name', field.name)
                                    .val(field.value)
                                    .appendTo(form);
                            });
                        }
                        if (options.fileInput && options.fileInput.length &&
                                options.type === 'POST') {
                            fileInputClones = options.fileInput.clone();
                            // Insert a clone for each file input field:
                            options.fileInput.after(function (index) {
                                return fileInputClones[index];
                            });
                            if (options.paramName) {
                                options.fileInput.each(function (index) {
                                    $(this).prop(
                                        'name',
                                        paramNames[index] || options.paramName
                                    );
                                });
                            }
                            // Appending the file input fields to the hidden form
                            // removes them from their original location:
                            form
                                .append(options.fileInput)
                                .prop('enctype', 'multipart/form-data')
                                // enctype must be set as encoding for IE:
                                .prop('encoding', 'multipart/form-data');
                        }
                        if (options.crossDomain) {
                            // listen for postMessage response
                            $(window).on("message.iframe-transport", function(e) {
                                e = e.originalEvent;
                                if (e.origin === siteURL) {
                                    $(window).off("message.iframe-transport");
                                    deferred.resolve("success", e.data);
                                }
                            });
                        }
                        form.submit();
                        // Insert the file input fields at their original location
                        // by replacing the clones with the originals:
                        if (fileInputClones && fileInputClones.length) {
                            options.fileInput.each(function (index, input) {
                                var clone = $(fileInputClones[index]);
                                $(input).prop('name', clone.prop('name'));
                                clone.replaceWith(input);
                            });
                        }
                    });
                    form.append(iframe).appendTo(document.body);
                },
                abort: function () {
                    if (iframe) {
                        // javascript:false as iframe src aborts the request
                        // and prevents warning popups on HTTPS in IE6.
                        // concat is used to avoid the "Script URL" JSLint error:
                        iframe
                            .unbind('load')
                            .prop('src', 'javascript'.concat(':false;'));
                    }
                    if (form) {
                        form.remove();
                    }
                }
            };
        }
    });

    // The iframe transport returns the iframe content document (as text) as response.
    // The following adds an equivalence converter from iframe to text;
    // jQuery will then handle the other conversions.
    $.ajaxSetup({
        converters: {
            'iframe text': true
        }
    });

}));

// Hack for JS.Require
var transport = transport || {};
transport.iframe = true;
